document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementsByClassName('tab').length) {
        Array.from(document.getElementsByClassName('tab')).forEach(tabEl => {
            tabEl.addEventListener('click', (event) => {
                openTab(tabEl, tabEl.dataset.target);
            })
        })
    }
});

function openTab(tabEl, tabId) {
    console.log(tabEl, tabId);
    var i, x, tablinks;
    x = document.getElementsByClassName('tab-content');
    for (i = 0; i < x.length; i++) {
        x[i].classList.remove('is-block');
        x[i].classList.add('is-hidden');
    }
    tablinks = document.getElementsByClassName('tab');
    for (i = 0; i < x.length; i++) {
        tablinks[i].classList.remove('is-active');
    }
    document.getElementById(tabId).classList.remove('is-hidden');
    document.getElementById(tabId).classList.add('is-block');
    tabEl.classList.add('is-active');
}
